var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-828.000000, -1217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(828.000000, 1217.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#104C8F",
    cx: 17,
    cy: 17,
    r: 16.25
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "mental-health-fill"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,2 C15.068,2 18.426,5.036 18.934,8.965 L21.184,12.504 C21.332,12.737 21.302,13.084 20.959,13.232 L19,14.07 L19,17 C19,18.105 18.105,19 17,19 L15.001,19 L15,22 L6,22 L6,18.306 C6,17.126 5.564,16.009 4.756,15.001 C3.657,13.631 3,11.892 3,10 C3,5.582 6.582,2 11,2 Z M10.47,7.763 C9.786,7.079 8.678,7.079 7.995,7.763 C7.311,8.446 7.311,9.554 7.995,10.237 L11,13.243 L14.005,10.237 C14.689,9.554 14.689,8.446 14.005,7.763 C13.322,7.079 12.214,7.079 11.53,7.763 L11,8.293 L10.47,7.763 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.024b20bbc1fa28566008fd631e4638b5.svg";
export { ForwardRef as ReactComponent };